import React, {useState, useEffect,useRef} from "react";
import axios from "axios";
import {Helmet} from 'react-helmet';
import { useLocation } from "react-router-dom";
import Style from '../styles/Contact.module.css';

const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d415071.5387380142!2d-82.669582!3d35.633978!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6031325ca1b2f97b%3A0xbd3fef53f0beb782!2sDino%20Construction!5e0!3m2!1sen!2sus!4v1688691122782!5m2!1sen!2sus";
const shouldLoadEmbeddedMap = () => navigator.userAgent !== "ReactSnap";
const formEndpoint = process.env.REACT_APP_FORM_ENDPOINT || "/api/form";
const maxPhotos = 10;

const Contact = () => {
    const location = useLocation();
    const formRef = useRef(null);
    const estimateSectionRef = useRef(null);
    const [hasMounted, setHasMounted] = useState(false);
        useEffect(() => {
            setHasMounted(shouldLoadEmbeddedMap());
          }, []);

        useEffect(() => {
            if (location.hash.toLowerCase() === "#estimate") {
              setTimeout(() => {
                estimateSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
              }, 0);
              return;
            }

            window.scrollTo(0, 0);
          }, [location.hash]);
          const [photos, setPhotos] = useState([]);
          const [isLoading, setIsLoading] = useState(false);
          const [isSubmitted,setIsSubmitted] = useState(false);
          const [submitError, setSubmitError] = useState("");

          const [firstName, setFirstName] = useState("");
          const [lastName, setLastName] = useState("");
          const [email, setEmail] = useState("");
          const [phone, setPhone] = useState("");
          const [serviceType, setServiceType] = useState("");
          const [additionalInfo, setAdditionalInfo] = useState("");
          const [address, setAddress] = useState("");
          const [city, setCity] = useState("");
          const [state, setState] = useState("");
          const [zipcode,setZipcode] = useState("");
          const [website, setWebsite] = useState("");

          
          
          const handleSubmit = async (event) => {
            event.preventDefault();
            setIsLoading(true);
            setSubmitError("");
          
            const formData = {
                firstName,
                lastName,
                email,
                phone,
                serviceType,
                additionalInfo,
                address,
                city,
                state,
                zipcode,
                website,
            };

            photos.forEach((photo, index) => {
               formData[`photo${index}`] = photo.src;
            });
            try {
                const response = await axios.post(formEndpoint, formData);
                if (!response.data) {
                  throw new Error('No response from form endpoint.');
                }
                setIsLoading(false);
                setIsSubmitted(true);
              } catch (error) {
                setIsLoading(false);
                const serverMessage = error.response?.data?.error || error.response?.data?.message;
                const localMessage = process.env.NODE_ENV === 'production'
                  ? ''
                  : ` ${serverMessage || error.message || ''}`.trim();
                setSubmitError(`Sorry, there was an error sending your message. Please call us or try again later.${localMessage ? ` (${localMessage})` : ''}`);
              }
            
              setFirstName("");
              setLastName("");
              setEmail("");
              setPhone("");
              setServiceType("");
              setAdditionalInfo("");
              setAddress("");
              setCity("");
              setState("");
              setZipcode("");
              setWebsite("");
            setPhotos([]);
          };
          

const readPhotoFile = (file) => new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve({
        name: file.name,
        src: reader.result,
      });
    };

    reader.readAsDataURL(file);
  });

const handlePhotoUpload = async (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) {
      return;
    }

    const availableSlots = maxPhotos - photos.length;

    if (availableSlots <= 0) {
      setSubmitError(`You can add up to ${maxPhotos} photos.`);
      event.target.value = "";
      return;
    }

    const selectedFiles = files.slice(0, availableSlots);
    const uploadedPhotos = await Promise.all(selectedFiles.map(readPhotoFile));

    setPhotos((prevPhotos) => [...prevPhotos, ...uploadedPhotos]);
    setSubmitError(files.length > availableSlots ? `Only ${maxPhotos} photos can be added.` : "");
    event.target.value = "";
  };

  const handlePhotoDelete = (index) => {
    setPhotos((prevPhotos) => prevPhotos.filter((photo, photoIndex) => photoIndex !== index));
  };
    return(
        <div>
            <Helmet>
                <title>Contact Us - Dino Constructions</title>
                <meta name="description" content="Contact Dino Constructions for any inquiries, questions or comments about our services." />
                <meta property="og:title" content="Contact Us - Dino Constructions" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://dinoconstructions.com/ContactUs" />
                <link rel="canonical" href="https://dinoconstructions.com/ContactUs"/>
                <meta property="og:description" content="Contact Dino Constructions for any inquiries, questions or comments about our services." />
            </Helmet>
            <div className={Style.Content1}>
                <div className={Style.Content1Intro}>
                    <p className={Style.heroEyebrow}>Start your project</p>
                    <h1>Request a construction estimate</h1>
                    <p>Tell us what you are planning, share a few photos if you have them, and we will follow up to discuss the best next step.</p>
                </div>
            </div>
            <div className={Style.Content2}>
                <div className={Style.PartA}>
                    <div className={Style.PartAHeading}>
                        <p className={Style.sectionKicker}>Dino Construction</p>
                        <h2>Serving Asheville and surrounding areas</h2>
                        <div className={Style.brLine}></div>
                        <p>Concrete, roofing, decks, fences, painting, stone patios, and block foundation work for local homeowners.</p>
                    </div>
                    <div className={Style.PartAHours}>
                        <h3>Open Monday-Friday</h3>
                        <p>7:00 AM - 6:00 PM</p>
                    </div>
                    <div className={Style.PartAButtons}>
                        <a href="tel:8287028101">Call Us</a>
                        <a href="mailto:Dino@DinoConstructions.com">Email Us</a>
                    </div>
                </div>
                <div className={Style.PartB}>
                {hasMounted && (
                <iframe src={mapEmbedUrl}
                    title="Map"
                    width="99.5%"
                    height="99%"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                )}
                 
                </div>
            </div>
            <div className={Style.Content3} id="Estimate" ref={estimateSectionRef}> 
            <div className={Style.FormIntro}>
                <p className={Style.sectionKicker}>Free estimate</p>
                <h2>Send us the project details</h2>
                <p>Use the form below or call us directly if you would rather talk through the work.</p>
            </div>
            <form id="form" className={Style.estimateForm} onSubmit={handleSubmit} ref={formRef} encType="multipart/form-data">
                    <div className={Style.HoneypotField} aria-hidden="true">
                        <label htmlFor="website">Website:</label>
                        <input
                        type="text"
                        id="website"
                        name="website"
                        value={website}
                        onChange={(event) => setWebsite(event.target.value)}
                        tabIndex="-1"
                        autoComplete="off"
                        />
                    </div>
                    <div className={Style.CustomerDetails}>
                        <h2>Contact Information</h2>
                        <div className={Style.CustomerContainer}>
                            <div className={Style.ContainerFirstName}>
                                <label htmlFor="firstName">First Name:</label>
                                <input 
                                type="text" 
                                id="firstName" 
                                name="firstName"
                                value={firstName}
                                onChange={(event) => setFirstName(event.target.value)}
                                required 
                                />
                            </div>
                            <div className={Style.ContainerLastName}>
                                <label htmlFor="lastName">Last Name:</label>
                                <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={lastName}
                                onChange={(event) => setLastName(event.target.value)}
                                required
                                />
                            </div>
                            <div className={Style.ContainerEmail}>
                                <label htmlFor="email">Email Address:</label>
                                <input
                                type="email"
                                id="email"
                                name="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                required
                                />
                            </div>
                            <div className={Style.ContainerPhone}>
                                <label htmlFor="phone">Phone:</label>
                                <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={phone}
                                onChange={(event) => setPhone(event.target.value)}
                                required
                                />
                            </div>
                            <div className={Style.ContainerService}>
                                <label htmlFor="serviceType">Service Type:</label>
                                <select
                                id="serviceType"
                                name="serviceType"
                                value={serviceType}
                                onChange={(event) => setServiceType(event.target.value)}
                                required
                                >
                                <option value="">Choose a service type</option>
                                <option value="Concrete">Concrete</option>
                                <option value="Paint">Paint</option>
                                <option value="Decks/Porches/Fences">Decks/Porches/Fences</option>
                                <option value="Roofing">Roofing</option>
                                <option value="Stone Patio">Stone Patio</option>
                                <option value="Block Foundation">Block Foundation</option>
                                </select>
                            </div>
                            <div className={Style.ContainerAdditionalInfo}>
                                <label htmlFor="additionalInfo">Project Notes:</label>
                                <textarea
                                className={Style.FixedTexarea}
                                id="additionalInfo"
                                name="additionalInfo"
                                value={additionalInfo}
                                onChange={(event) => setAdditionalInfo(event.target.value)}
                                rows={10}
                                cols={60}
                                ></textarea>
                        </div>
                    </div>
                    </div>
                    <div className={Style.VerticalBrk}></div>
                    <div className={Style.ProjectContainer}>
                        <h2>Project Details</h2>
                        <div className={Style.ProjectDetails}>
                            <div className={Style.ContainerAddress}>
                                <label htmlFor="address">Address:</label>
                                <input 
                                type="text" 
                                id="address" 
                                name="address"
                                value={address} 
                                onChange={(event)=> setAddress(event.target.value)} 
                                required />
                            </div>
                            <div className={Style.ContainerCity}>
                                <label htmlFor="city">City:</label>
                                <input 
                                type="text" 
                                id="city" 
                                name="city"
                                value={city}
                                onChange={(event)=>setCity(event.target.value)} 
                                required />
                            </div>
                            <div className={Style.ContainerState}>
                            <label htmlFor="state">State:</label>
                        <select 
                        id="state" 
                        name="state"
                        value={state}
                        onChange={(event)=> setState(event.target.value)} 
                        required>
                            <option value="">--Please select a state--</option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option> 
                    </select>
                            </div>
                            <div className={Style.ContainerZipCode}>
                            <label htmlFor="zipcode">Zipcode:</label>
                            <input 
                            type="text" 
                            id="zipcode" 
                            name="zipcode"
                            value={zipcode} 
                            onChange={(event)=>setZipcode(event.target.value)}
                            required />
                            </div>
                        </div>
                        <div className={Style.PhotoContainer}>
                            <h2>Include Some Photos</h2>
                            <p>Photos are optional. Add up to {maxPhotos} photos so we can understand the project faster.</p>
                            <div className={Style.PhotoUploadArea}>
                                <label htmlFor="projectPhotos">
                                    <span>Add project photos</span>
                                    <small>{photos.length}/{maxPhotos} selected</small>
                                </label>
                                <input
                                type="file"
                                id="projectPhotos"
                                name="photos"
                                accept="image/*"
                                multiple
                                onChange={handlePhotoUpload}
                                disabled={photos.length >= maxPhotos}
                                />
                            </div>
                            {photos.length > 0 && (
                            <div className={Style.PhotoList}>
                                {photos.map((photo, index) => (
                                <div className={Style.PhotoRow} key={`${photo.name}-${index}`}>
                                    <img src={photo.src} alt={`Project upload ${index + 1}`} decoding="async" />
                                    <div>
                                        <strong>Photo {index + 1}</strong>
                                        <span>{photo.name}</span>
                                    </div>
                                    <button type="button" onClick={() => handlePhotoDelete(index)} aria-label={`Remove photo ${index + 1}`}>Remove</button>
                                </div>
                                ))}
                            </div>
                            )}
                       </div>
                    </div>
                    <div className={Style.SubmitForm}>
                        {submitError && <p className={Style.ErrorMessage}>{submitError}</p>}
                        {isSubmitted ? (
                            <div className={Style.SuccessMessage}>Message sent. We will follow up soon.</div>
                        ) : (
                            <button className={`${Style.SubmitButton} ${isLoading ? Style.Loading : ''}`} type="submit" disabled={isLoading}>
                            {isLoading ? <div className={Style.Loader}></div> : 'Send Estimate Request'}
                            </button>
                        )}
                 </div>

                </form>
            </div>

        </div>
    );
}

export default Contact;
